import ActionTypes from "../../../constants/ActionTypes";
import { IProductsState } from "../product/productList/types";
import { IAddProductOnWishListAction, IRemoveProductFromWishListAction, ISetProductIdsForWishListAction, ISetProductsForWishListAction, IWishListProductChangeAction, IWishListSaveProductIdActionAction } from "./types";

export const wishListGetProductsAction = (): any => ({
  type: ActionTypes.WISH_LIST.GET_PRODUCTS
});

export const wishListProductChangeAction = (status: boolean, productId: number, languge: string, section: string, type: string): IWishListProductChangeAction => ({
  type: ActionTypes.WISH_LIST.CHANGE_PRODUCT,
  payload: {
    status,
    productId,
    lang: languge,
    section,
    type
  }
});

export const wishListSaveProductIdAction = (status: boolean, productId: number, languge: string, section: string, type: string): IWishListSaveProductIdActionAction => ({
  type: ActionTypes.WISH_LIST.SAVE_PRODUCT_AFTER_LOGIN,
  payload: {
    status,
    productId,
    lang: languge,
    section,
    type
  }
});

export const addProductOnWishListAction = (productId: number): IAddProductOnWishListAction => ({
  type: ActionTypes.WISH_LIST.ADD_PRODUCT_ON_WISH_LIST,
  payload: productId
});

export const removeProductFromWishListAction = (productId: number): IRemoveProductFromWishListAction => ({
  type: ActionTypes.WISH_LIST.REMOVE_PRODUCT_FROM_WISH_LIST,
  payload: productId
});

export function setProductsForWishListAction(products: IProductsState[]): ISetProductsForWishListAction {
  return {
    type: ActionTypes.WISH_LIST.SET_PRODUCTS,
    payload: products,
  };
}

export function setProductIdsForWishListAction(productsIds: number[]): ISetProductIdsForWishListAction {
  return {
    type: ActionTypes.WISH_LIST.SET_PRODUCT_IDS,
    payload: productsIds,
  };
}
